import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { insertUpdateIndustrySegmentMasterListUrl, INSERT_UPDATE_INDUSTRY_SEGMENT_MASTER, headers } from "../../../utils/constants";

// export const deleteManualformsMaster_action = (ExihibitionID, ManualFormMappingID) => async (dispatch) => {
//     try {
//         const params = {
//             UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
//             ExhibitionID: ExihibitionID,
//             ManualFormMappingID: ManualFormMappingID

//         }
//         console.log("getVisaInvitation_action Action------->", params)

//         const res = await axiosGet(deleteManualFormsMasterUrl, params, headers)

//         dispatch({
//             type: DELETE_MANUAL_FORMS_MASTER,
//             payload: res,
//         });
//         return Promise.resolve(res)
//     } catch (error) {
//         return Promise.reject(error)
//     }
// }

export const insertUpdateIndustrySegmentMaster_action = (industrySegmentList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: ExihibitionID,
            industrySegmentList: industrySegmentList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateIndustrySegmentMasterListUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_INDUSTRY_SEGMENT_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}